import { useLocation } from '@remix-run/react';
import { useEffect } from 'react';
import { gaPageView } from './GAUtils';

interface GARootScriptProps {
	gaTrackingId: string;
}

const LOADER_ID = 'gtag-loader';

export function GARootScript({ gaTrackingId }: GARootScriptProps) {
	const useGa = !!gaTrackingId?.length;
	const location = useLocation();

	useEffect(() => {
		if (!useGa) return;
		if (document.getElementById(LOADER_ID)) return;
		const script = document.createElement('script');
		script.id = LOADER_ID;
		script.async = true;
		script.src = `https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}`;
		document.head.appendChild(script);
	}, [useGa, gaTrackingId]);

	useEffect(() => {
		if (useGa) {
			gaPageView(location.pathname, gaTrackingId);
		}
	}, [location, gaTrackingId, useGa]);

	return useGa ? (
		<script
			id="gtag-init"
			dangerouslySetInnerHTML={{
				__html: `
					window.dataLayer = window.dataLayer || [];
					function gtag(){dataLayer.push(arguments);}
					window.gtag = gtag;
					gtag('js', new Date());
					gtag('config', '${gaTrackingId}', {
						page_path: window.location.pathname,
					});
				`,
			}}
		/>
	) : null;
}
